import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from, Subject } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject = new Subject<boolean>();

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getAccessToken();
    const language = localStorage.getItem('language');
    let authReq = req;
    if (token) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}`,
        'Accept-language': language ?? 'it' }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorCode = error.error?.errorCode;

        if (errorCode === 'error.token.expired') {
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject = new Subject<boolean>();

            return from(this.authService.refreshAccessToken()).pipe(
              switchMap(success => {
                this.isRefreshing = false;
                this.refreshTokenSubject.next(success);
                this.refreshTokenSubject.complete();

                if (success) {
                  const newToken = this.authService.getAccessToken();
                  const retryReq = req.clone({
                    setHeaders: { Authorization: `Bearer ${newToken}`,
                      'Accept-language': language ?? 'it' }
                  });
                  return next.handle(retryReq);
                } else {
                  this.authService.logout();
                  return throwError(() => error);
                }
              })
            );
          } else {
            // Coda: aspetto che il primo refresh finisca
            return new Observable<HttpEvent<any>>(observer => {
              this.refreshTokenSubject.subscribe(success => {
                if (success) {
                  const newToken = this.authService.getAccessToken();
                  const retryReq = req.clone({
                    setHeaders: { Authorization: `Bearer ${newToken}`,
                      'Accept-language': language ?? 'it' }
                  });
                  next.handle(retryReq).subscribe({
                    next: val => observer.next(val),
                    error: err => observer.error(err),
                    complete: () => observer.complete()
                  });
                } else {
                  observer.error(error);
                }
              });
            });
          }
        }

        if (errorCode === 'error.session.expired' || errorCode === 'error.no.session') {
          this.authService.logout();
        }

        return throwError(() => error);
      })
    );
  }
}
